// import '../../Styles/css/Cra.css';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button } from '@mui/material';
import dayjs from 'dayjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import React, { useEffect,useMemo,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';

import logoDataDelegates from '../../../src/Assets/LOGOHTH.png';
import EventModal from '../../Components/cra/EventModal';
import Month from '../../Components/cra/Month';
import { buttonStyles } from '../../Components/docsAdministrative/JsObjectStyles';
//import { getFormattedDate } from '../../data/Interfaces';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useCraRdv from '../../hooks/useCraRdv';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
// import useGetRequest from '../../hooks/useGetRequest';
import useRole from '../../hooks/useRole';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { getCalendarMonthMatrix, getCountryHolidays } from '../../Utils/getCalendarMonthMatrix';
import { getNomPrenomClearFromPersoData } from '../../Utils/utils';

const Cra = () => {
    const axiosPrivate = useAxiosPrivate();
    const role = useRole();
    const {craId} = useParams();
    const [cra, setCra] = useState();
    const [evts, setEvts] = useState([]);
    const { i18n } = useTranslation();
    const [esnIsAchat,setEsnIsAchat]=useState();
    usePersistedLanguage();
    console.log({FromState: craId, FromURL: craId});
    const location = useLocation();
    // const currenMonth = getCalendarMonthMatrix({monthCra: parseInt(cra?.month) - 1,yearCra:cra?.year });
    // const [currenMonth, setCurrentMonth] = useState(getMonthCRA());
    // const [currenMonth, setCurrentMonth] = useState();
    const { showEventModal } =useCraRdv();
    // const [monthI, setMonthI] = useState(0);
    const [dateDebutBDC, setDateDebutBDC] = useState();
    const [dateFinBDC, setDateFinBDC] = useState();
    //==================ici on peut ajouter l'abreviation du pays:tous cela est dans
    //la documentation du biblio================================================

    useEffect(() => {
        if(location && role){
            console.log('location',location);
            const currentUrl = location.pathname;
            console.log('currentUrl currentUrl',currentUrl,'condition',!currentUrl.includes('craVente'));
            if(role=='esn' && !currentUrl.includes('craVente'))
                setEsnIsAchat(true);
            else if(role=='esn' && currentUrl.includes('craVente'))
                setEsnIsAchat(false);
        }
    }, [location,role]);

    const currenMonth = useMemo(() =>
        getCalendarMonthMatrix({monthCra: parseInt(cra?.month) - 1,yearCra:cra?.year,pays:(cra?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop() ?? cra?.missionId?.esnId?.profileEntreprise?.localisation?.split('/')?.pop())}), [cra]);

    const holiday = useMemo(() => {
        if (cra) {
            switch (cra?.missionId?.companyDataId?.profileEntreprise?.localisation.split('/').pop().toLowerCase() ?? cra?.missionId?.esnId?.profileEntreprise?.localisation.split('/').pop().toLowerCase()) {
            case 'fr':
                return getCountryHolidays('fr');
            case 'be':
                return getCountryHolidays('be');
            case 'ma':
                return getCountryHolidays('ma');
            default:
                return getCountryHolidays('fr');
            }
        }
    }, [cra]);

    //const holiday = useMemo(async () => {
    //    const formattedDate = getFormattedDate(cra?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop() || 'fr');
    //    const holidays = await getCountryHolidays(cra?.craId, formattedDate);
    //    return holidays;
    //}, [cra]);

    //const [holiday,setHoliday]=useState();

    const holidaysDuMoisDuCra = useMemo(() => {
        if (holiday) {
            return holiday.map((hol) => {
                if (hol?.type === 'public') {
                    const moisDuCra = parseInt(cra?.month);
                    const moisDuHoliday = parseInt(hol.date.split(' ')[0].split('-')[1]);
                    return moisDuCra === moisDuHoliday ? hol.date.split(' ')[0].split('-').reverse().join('-') : null;
                }
                return null;
            });
        }
        return [];
    }, [cra, holiday]);
    const listDay = useMemo(()=>
    //  {
    //     // debugger;
    //     let tempArray=[];
        evts.map((ev) => {if(ev.day !== undefined) return ev.day;}
        // evts.filter((ev) => ev.day !== undefined
        // ) { tempArray.push(ev.day); }
            // console.log('titi',tempArray);
            // return tempArray;
        // }
        )
    // }
    , [evts] );
    //===============================getEvents================================
    // ! Event == day of CRA from the current month of CRA [avec les details : 0j, 0.5j , 1j]

    console.log('tata',{ listDay, evts,currenMonth,holidaysDuMoisDuCra});

    //===========================pour les jour ou on n'a pas d events on oura une
    //valeur undefined donc ici listDay comme un filtre pour avoir les days ou
    // on a des events on va exploiter cela dans modal ... ====================
    // let listDay = [];
    // // evts.map((ev) => { if (ev.day !== undefined) { listDay.push(ev.day) } });
    // useEffect(() => {
    //     listDay = [];
    //     evts.map((ev) => { if (ev.day !== undefined) { listDay.push(ev.day); } });
    //     console.log('EVTS',evts);
    // }, [evts]);

    //==============getMonthC le la matrice avec mois correspondant au cra==================
    useEffect(() => {
        if(craId && ((role=='esn' && esnIsAchat !== undefined) || role!='esn')){
        // setMonthI(parseInt(cra?.month) - 1);
        // ! the probleme is here
        // setCurrentMonth(getMonthCRA(monthI));
            getCraById();
            // .then(()=>{
            // ! Why I had this API Call here, it's already in the getCraById, so I commented it
            // getEventByCra();
            getDateDebutFinBDCByCraId();
            // }
            // );
        }
    }, [craId,role,esnIsAchat]);

    const getDateDebutFinBDCByCraId = async () => {
        try {
            const response = await axiosPrivate.get('cra/getDateDebutFinBDCByCraId/' + craId);
            console.log(response.data?.bdc);
            setDateDebutBDC(response.data?.bdc?.dateDebutBDC);
            setDateFinBDC(response.data?.bdc?.dateFinBDC);
        } catch (error) {
            console.log(error);
        }
    };

    const getEventByCra = async () => {
        try {
            console.log('HELLO FROM the get getAll cras useEffect');
            const response = await axiosPrivate.get('/event/getEventByCra/' + craId);
            // console.log(response.data);
            let arr = response.data.data;
            console.log('arr arr arr',arr);
            setEvts(arr);
        } catch (error) {
            console.log(error);
        }
    };

    const getCraById = async () => {
        try {
            console.log('esnIsAchat esnIsAchat',esnIsAchat);
            const response = await axiosPrivate.get(`/cra/getCraById/${craId}${(role=='esn' ?(esnIsAchat==true ? '?isAchat=true':'?isAchat=false'): '')}`, {
                // signal: controller.signal
            });
            //?  if is mounted==true do next [setUsers..]
            // setCras2(response.data.data)
            // let arr = await response.data?.cras;
            const tempCra = await response.data?.cra;
            if(tempCra){
                // DRY
                let colaboratorId=tempCra?.collaboratorId ?? tempCra?.collaboratorEsnId;
                let craWithAdaptedData = {
                    'craId': tempCra?.craId,
                    'intituleMission': tempCra?.missionId?.titre,
                    'statutCra': tempCra?.statutCra,
                    'dateValidationExpert': formatDateJJMMYYYY(tempCra?.DateVE),
                    'dateValidationClient': formatDateJJMMYYYY(tempCra?.DateVC),
                    //formatDateJJMMYYYY(facture?.craId?.DateVE) - formatDateJJMMYYYY(facture?.craId?.DateVC)
                    'month':
                        dayjs(new Date(dayjs().year(), tempCra?.month - 1))
                            .locale('fr').format('MMMM'),
                    'year': tempCra?.year,
                    'nbJour': tempCra?.nbrDays,
                    // /? Cra X
                    'totalAstreintes': '--',
                    'totalHno': '--',
                    'totalNotesFrais': '--',
                    // ? son't les colonnes qui controle l'affichage
                    'refClient': tempCra?.missionId?.companyDataId?.clientId,
                    'nomClient': tempCra?.missionId?.companyDataId?.profileEntreprise?.nom ?? tempCra?.missionId?.esnId?.profileEntreprise?.nom,
                    'nomCollab': colaboratorId ? getNomPrenomClearFromPersoData(colaboratorId?.persoData) : null,
                    // TODO: REPLACE IT BY EXPERTID existed inside cra itself ,, it's also a backend task
                    'refExpert': tempCra?.missionId?.expertId?.expertId,
                    'nomExpert':  getNomPrenomClearFromPersoData(tempCra?.missionId?.expertId?.persoData),
                };
                if (role == 'expert' || role == 'admin' || (role=='esn' && esnIsAchat==false)) {
                    craWithAdaptedData = { ...craWithAdaptedData , ...{
                        'tjExpert': tempCra?.tj,
                        'totalHtExpert': tempCra?.nbrDays * tempCra?.tj,
                    }};
                }
                else if (role == 'client' || role == 'admin' || (role=='esn' && esnIsAchat==true)) {
                    craWithAdaptedData = { ...craWithAdaptedData , ...{
                        'tjClient': tempCra?.tjClient,
                        'totalHtClient':  Number(tempCra?.nbrDays) * tempCra?.tjClient,
                    }};
                }
                if (role == 'admin') {
                    craWithAdaptedData = { ...craWithAdaptedData , ...{
                        'responsableOperationnel': getNomPrenomClearFromPersoData(tempCra?.bdcId?.responsableOperationnelId?.persoData),
                        'chargeRecrutement': getNomPrenomClearFromPersoData(tempCra?.bdcId?.backOfficeId?.persoData),
                    }};
                }
                // add other Infos
                craWithAdaptedData = {...craWithAdaptedData, ...tempCra};
                setCra(craWithAdaptedData);
                getEventByCra();
                // else return;
            }
        } catch (error) {
            console.log('refreshCra', error);
        }
    };
    const handleGeneratePdf = () => {
        const divToCapture = document.getElementById('yes');
        const padding = 10; // Padding in pixels

        html2canvas(divToCapture).then(canvas => {
            const pdf = new jsPDF('landscape'); // Specify landscape mode
            const imgData = canvas.toDataURL('image/jpeg', 0.3);

            // Calculate the height of the image in the PDF
            const imgHeight = (canvas.height * pdf.internal.pageSize.getWidth()) / canvas.width;
            const fileName='CRA_'+cra?.nomExpert+'_'+cra?.month+cra?.year+'_'+cra?.nomClient+'.pdf';
            // Add logo to the captured image
            const logoImg = new Image();
            logoImg.src = logoDataDelegates;
            const text1=i18n.t('Validé par ')+cra?.nomExpert +i18n.t(' le ')+formatDateJJMMYYYY(cra?.DateVE);
            const text2=i18n.t('Validé par ')+ cra?.nomCollab  +i18n.t(' le ')+formatDateJJMMYYYY(cra?.DateVE);
            logoImg.onload = () => {
                const imgWidth = pdf.internal.pageSize.getWidth() - (2 * padding);
                const logoHeight = (50 * imgHeight) / canvas.height; // Adjust logo height
                pdf.addImage(logoImg, 'PNG', padding, padding, 50, logoHeight); // Adjust logo size and position
                pdf.addImage(imgData, 'PNG', padding, logoHeight + 2 * padding, imgWidth, imgHeight - logoHeight - (4 * padding));
                // Set font size and style for dynamic content
                pdf.setFontSize(11); // Set font size
                pdf.setCharSpace(0);
                // Add text below the image
                if(cra?.statutCra=='VE')
                    pdf.text(text1, padding, imgHeight-10);
                if(cra?.statutCra=='VC'){
                    pdf.text(text1, padding, imgHeight-10);
                    pdf.text(text2, padding, imgHeight );
                }
                pdf.save(fileName);
                console.log(cra);
            };
        });

    };

    //'Validé par "Nom de l'Expert" le "Date de validation"`
    // useEffect(() => {
    //     console.log('----------');
    //     console.log({holiday,holidaysDuMoisDuCra,evts,listDay,state: cra,currenMonth,dateDebutBDC});
    // }, [holiday,holidaysDuMoisDuCra,evts,listDay,params,currenMonth,dateDebutBDC]);
    // useEffect(() => {
    //     console.log('++++++++++');
    //     console.log({currenMonth,monthI,craDate: cra?.month});
    //     // console.log({1: getMonthCRA(currenMonth),2: getMonthCRA(monthI),3: getMonthCRA(cra?.month)});
    // }, [currenMonth]);

    // useEffect(() => {
    //     console.log('##########################');
    //     console.log({currenMonth
    //         // ,monthI
    //         ,craDate: cra?.month});
    // }, [currenMonth]);
    //=======================================================================

    return (
        <React.Fragment>
            {/* by  defalt showEventModal is false, but it can be modified somewhere else */}

            {(showEventModal && (role == 'expert' || (role=='esn' && esnIsAchat==false)) && cra?.factureId?.statutFacture !== 'genere') &&
            <EventModal
                evts={listDay}
                idCra={craId}
                holidaysDuMoisDuCra={holidaysDuMoisDuCra}
                refreshCra={getCraById}
            />}
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                <div className='frame5Profile'>
                    {i18n.t('CRA & Factures')} &gt;  <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Compte rendu d\'activité')}</span>
                </div>

                <Button
                    className='TelechargerMissionOM'
                    variant="text"
                    style={{ ...buttonStyles(), ...{color: '#272D3C', background: '#E7EAF9',fontFamily:'lato', borderRadius:'10px',}}}
                    startIcon={<FileDownloadOutlinedIcon style={{ color: '#272D3C' }} />}
                    onClick={handleGeneratePdf}
                >
                    {i18n.t('Télécharger')}
                </Button>
            </div>
            <div
                id='yes'
                style={{width:'100%'}}
            >
                <div className='HomeFrame'>
                    <Month
                        currenMonth={currenMonth} //currenMonth is a matrix
                        cra={cra}
                        refreshCra={getCraById}
                        // since the request is async =, we first passed empty event to month, then we update the value
                        evts={evts}
                        holidaysDuMoisDuCra={holidaysDuMoisDuCra}
                        idCra={craId}
                        // on doit passer dateDebutBDC pour griser les jours du mois avant le debut de BDC dans le cra
                        dateDebutBDC={dateDebutBDC}
                        dateFinBDC={dateFinBDC}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default Cra;
